import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {BaseService} from '~/app/core/common/services/base.service';

import {ApiService} from '~/app/core/common/services/api.service';
import {StoreListService} from '~/app/core/common/services/store-list.service';
import {GoogleAnalyticsService} from '~/app/core/common/services/google-analytics.service';
import {ApplicationSettingsHelper} from '~/app/shared/helpers/application-settings-helper';
import {InternetConnectionService} from '~/app/shared/services/internet-connection.service';
import {ErrorApiService} from '~/app/core/common/test/error-api.service';
import {Store} from '~/app/core/common/models/store';

@Injectable({
    providedIn: 'root'
})
export class MogService extends BaseService {

    private _initialized: boolean;
    public groupNo = '0';
    public storeString = '';
    public updateGrp = '';

    constructor(private _http: HttpClient,
                public apiService: ApiService,
                private _storeListService: StoreListService,
                public googleAnalyticsService: GoogleAnalyticsService,
                public internetConnectionService: InternetConnectionService,
                public errorApiService: ErrorApiService,
                public baseService: BaseService,
                public applicationSettingsHelper: ApplicationSettingsHelper) {
        super(_http,
            googleAnalyticsService,
            internetConnectionService,
            errorApiService,
            applicationSettingsHelper);
        this.initialized = false;
    }

    get initialized(): boolean {
        return this._initialized;
    }

    set initialized(value: boolean) {
        this._initialized = value;
    }

    public async update(grpNo: string, stores: Store[]) {
        this.groupNo = '0';
        if (grpNo !== null) {
            if (grpNo === 'newgroup') {
                this.groupNo = await this.baseService.getHttp(
                    'getGrpNo',
                    'mog-service',
                    this.apiService.mogSelectNewGroupURL)
                    .toPromise()
                    .then((results) => results as string);
            } else {
                this.groupNo = grpNo;
            }
        }

        for (const store of stores) {
            if (store.customerId.toString() !== '000000') {
                // If not the first store in the stores list
                if (this.groupNo !== '0' && grpNo !== 'newgroup') {
                    await this.baseService.putHttp(
                        'updateGrp',
                        'mog-service',
                        this.apiService.mogSyncOrderGuideURL
                            .replace('store_number', store.customerId.toString())
                            .replace('group_number', this.groupNo))
                        .toPromise()
                        .then(result => result);
                }
                this.storeString += store + ',';
                await this.baseService.putHttp(
                    'updateGrp',
                    'mog-service',
                    this.apiService.mogUpdateGroupURL
                        .replace('store_number', store.customerId.toString())
                        .replace('group_number', this.groupNo))
                    .toPromise()
                    .then(result => result);
            }
        }
    }
}
